import { AxiosError } from 'axios'
import { useCallback, useMemo } from 'react'
import { useMutation, UseMutationOptions } from 'react-query'
import { OAuthOtpRequest } from '../interfaces/OAuthOtpRequest'
import { OAuthErrorResponse } from '../interfaces/OAuthErrorResponse'
import { OAuthInteractionResponse } from '../interfaces/OAuthInteractionResponse'
import { useIamManagerOAuth } from '../useIamManagerOAuth'

type Response = OAuthInteractionResponse
export type UseOAuthOtpOptions = UseMutationOptions<
  Response,
  AxiosError<OAuthErrorResponse>,
  OAuthOtpRequest
>

export const useOAuthOtp = (options?: UseOAuthOtpOptions) => {
  const { endpoint, verifyOtp } = useIamManagerOAuth()
  const mutationKey = useMemo(() => [endpoint, 'verifyOtp'], [endpoint])
  const mutationFn = useCallback(
    async (input: OAuthOtpRequest) => (await verifyOtp(input)).data,
    [verifyOtp]
  )
  return useMutation<Response, AxiosError<OAuthErrorResponse>, OAuthOtpRequest>({
    ...options,
    mutationKey,
    mutationFn,
    retry: false
  })
}
